import { isEmpty } from 'lodash';

export type ChecklistItem = {
  description: string;
  complete?: boolean;
};

export function isChecklistItemDescriptionValid(
  length: number,
  index: number,
  description: string
): boolean {
  if (index === length - 1) {
    return true;
  }

  /**
   * we onlye need to validate the item if the checklist has more than one item
   * the first item is a placeholder and is not required
   */
  return !isEmpty(description);
}

export function isChecklistValid(checklist?: ChecklistItem[] | null): boolean {
  if (!Array.isArray(checklist)) {
    return false;
  }

  if (checklist.length === 0) {
    return true;
  }

  return checklist.every((item: ChecklistItem, index: number) =>
    isChecklistItemDescriptionValid(checklist.length, index, item.description)
  );
}
